(function(){
    'use strict';

    angular
    .module('app')
    .controller('GenericconfigController', GenericconfigController)
 
    GenericconfigController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function GenericconfigController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.busqueda = false;
        vm.field = "";
        vm.update = function(){
            var j = JSON.parse($('#fieldconfig-value').val());

			
            j.references["busqueda"] = vm.busqueda;
            j.references["field"] = vm.field;
            j.references["modificable"] = vm.modificable;

			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        }
        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
        		if(typeof vm.json.references.busqueda!='undefined'){
                    vm.busqueda = vm.json.references.busqueda;
                }
                if(typeof vm.json.references.field!='undefined'){
                    vm.field = vm.json.references.field;
                }
                if(typeof vm.json.references.modificable!='undefined'){
                    vm.modificable = vm.json.references.modificable;
                }
        	}
        	vm.update();
        }
    } 

})();